const PAYMENT_COUNTRY_TIMEZONES = {
    EE: "Europe/Tallinn",
    LV: "Europe/Riga",
    LT: "Europe/Vilnius",
    PL: "Europe/Warsaw",
    FI: "Europe/Helsinki",
};

export const getAffiliateTimeZone = (paymentCountry) =>
    PAYMENT_COUNTRY_TIMEZONES[String(paymentCountry || "EE").trim().toUpperCase()] || "Europe/Tallinn";

const dateKeyPattern = /^(\d{4})-(\d{2})-(\d{2})$/;

export const getDateKeyInTimeZone = (value, timeZone) => {
    if (value == null || value === "") return "";
    const date = value instanceof Date ? value : new Date(value);
    if (Number.isNaN(date.getTime())) return "";
    return new Intl.DateTimeFormat("en-CA", {
        timeZone,
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
    }).format(date);
};

export const localDateToDateKey = (value) => {
    if (value == null || value === "") return "";
    const date = value instanceof Date ? value : new Date(value);
    if (Number.isNaN(date.getTime())) return "";
    return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
};

export const addDaysToDateKey = (dateKey, days) => {
    const match = dateKeyPattern.exec(dateKey || "");
    if (!match) return "";
    const utc = new Date(Date.UTC(Number(match[1]), Number(match[2]) - 1, Number(match[3]) + days));
    return `${utc.getUTCFullYear()}-${String(utc.getUTCMonth() + 1).padStart(2, "0")}-${String(utc.getUTCDate()).padStart(2, "0")}`;
};

/** Calendar-day difference. Positive when toKey is after fromKey. */
export const diffDateKeys = (fromKey, toKey) => {
    const from = dateKeyPattern.exec(fromKey || "");
    const to = dateKeyPattern.exec(toKey || "");
    if (!from || !to) return null;
    const fromUtc = Date.UTC(Number(from[1]), Number(from[2]) - 1, Number(from[3]));
    const toUtc = Date.UTC(Number(to[1]), Number(to[2]) - 1, Number(to[3]));
    return Math.round((toUtc - fromUtc) / (24 * 60 * 60 * 1000));
};

/** Monday = 0 ... Sunday = 6 for a calendar date key. */
export const getWeekdayIndex = (dateKey) => {
    const match = dateKeyPattern.exec(dateKey || "");
    if (!match) return 0;
    const utcDay = new Date(Date.UTC(Number(match[1]), Number(match[2]) - 1, Number(match[3]))).getUTCDay();
    return utcDay === 0 ? 6 : utcDay - 1;
};

export const getWeekStartKey = (dateKey) => addDaysToDateKey(dateKey, -getWeekdayIndex(dateKey));

export const formatDateKeyDisplay = (dateKey) => {
    const match = dateKeyPattern.exec(dateKey || "");
    if (!match) return "";
    return `${match[3]}.${match[2]}.${match[1]}`;
};

export const formatDateKeyLong = (dateKey, locale = "en-US") => {
    const match = dateKeyPattern.exec(dateKey || "");
    if (!match) return "";
    const utcNoon = new Date(Date.UTC(Number(match[1]), Number(match[2]) - 1, Number(match[3]), 12));
    return new Intl.DateTimeFormat(locale, {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
        timeZone: "UTC",
    }).format(utcNoon);
};

export const toCivilDateKey = (value, timeZone) => {
    if (value == null || value === "") return "";
    if (typeof value === "string" && dateKeyPattern.test(value)) return value;
    if (timeZone) return getDateKeyInTimeZone(value, timeZone);
    return localDateToDateKey(value);
};
